import { render, staticRenderFns } from "./ProjectStateEmailList.vue?vue&type=template&id=19b800f2&"
import script from "./ProjectStateEmailList.vue?vue&type=script&lang=js&"
export * from "./ProjectStateEmailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports